import { Modal, Paragraph, tokens } from '@welbe/web-design-system';
import { Button, Clipboard, IconButton } from '@welbe/design-system';
import React from 'react';
import { FiPaperclip } from 'react-icons/fi';
import {
	CopyWrapper,
	Footer,
	Header,
	HeaderRow,
	TableCell,
	TableHead,
	TableWrapper,
} from './ModalMultipleExternalOrder.styles';

type ModalMultipleExternalOrderProps = {
	name: string;
	groupedExams: any[];
	onDownload: (id: string) => void;
	onClose: () => void;
};

export const ModalMultipleExternalOrder = ({
	name,
	groupedExams,
	onDownload,
	onClose,
}: ModalMultipleExternalOrderProps) => {
	return (
		<Modal
			open
			width="800px"
			padding="24px"
			onClose={onClose}
			preventBackdropClose
			headerIcon={<FiPaperclip size="28px" color="white" />}
		>
			<div>
				<Header>
					<Paragraph
						fontSize="16px"
						fontWeight="600"
						textAlign="center"
						color={tokens.color_primary}
					>
						Detalles de múltiples folios
					</Paragraph>
					<Paragraph fontSize="14px" fontWeight="600" textAlign="center">
						Los folios del candidato {name} se encuentran en los siguientes
						laboratorios:
					</Paragraph>
				</Header>

				<TableWrapper>
					<table>
						<HeaderRow>
							<TableHead $width="85px">ID</TableHead>
							<TableHead $width="300px">Examenes</TableHead>
							<TableHead $width="125px">Laboratorio</TableHead>
							<TableHead $width="111px">Folio</TableHead>
							<TableHead $width="110px">Acciones</TableHead>
						</HeaderRow>
						<tbody>
							{groupedExams.map((exam: any, index: number) => (
								<tr key={index}>
									<TableCell>
										<CopyWrapper>
											<Clipboard.Root value={exam.appointmentId}>
												<Clipboard.Trigger>
													<IconButton variant="ghost" size="xs">
														<Clipboard.Indicator />
													</IconButton>
												</Clipboard.Trigger>
											</Clipboard.Root>
											<Paragraph
												title={exam.appointmentId}
												elipsis
												width="50px"
											>
												{exam.appointmentId}
											</Paragraph>
										</CopyWrapper>
									</TableCell>
									<TableCell>
										{exam.exams.map((exam: any, index: number) => (
											<div key={index}>{exam}</div>
										))}
									</TableCell>
									<TableCell>{exam.healthCenter}</TableCell>
									<TableCell>{exam.externalOrderId}</TableCell>
									<TableCell $padding="0px">
										<Button
											variant="ghost"
											size="xs"
											onClick={() => onDownload(exam.appointmentId)}
										>
											<FiPaperclip /> Ver folio
										</Button>
									</TableCell>
								</tr>
							))}
						</tbody>
					</table>
				</TableWrapper>
				<Footer>
					<Button variant="outline" width="182px" onClick={onClose}>
						Cerrar
					</Button>
				</Footer>
			</div>
		</Modal>
	);
};
